/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InternalTagDTO } from '../models/InternalTagDTO';
import type { InternalTagDTOODataListResponse } from '../models/InternalTagDTOODataListResponse';
import type { Tag } from '../models/Tag';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InternalTagService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns InternalTagDTOODataListResponse Success
     * @throws ApiError
     */
    public static getInternalTag(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<InternalTagDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/Tag',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns InternalTagDTO Success
     * @throws ApiError
     */
    public static postInternalTag(
requestBody?: InternalTagDTO,
): CancelablePromise<InternalTagDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/Tag',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns InternalTagDTO Success
     * @throws ApiError
     */
    public static getInternalTag1(
key: number,
): CancelablePromise<InternalTagDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/Tag/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns InternalTagDTO Success
     * @throws ApiError
     */
    public static putInternalTag(
key: number,
requestBody?: InternalTagDTO,
): CancelablePromise<InternalTagDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal/Tag/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteInternalTag(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/internal/Tag/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param clientId 
     * @param query 
     * @returns Tag Success
     * @throws ApiError
     */
    public static getInternalTagQuery(
clientId?: number,
query?: string,
): CancelablePromise<Array<Tag>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/Tag/query',
            query: {
                'clientId': clientId,
                'query': query,
            },
        });
    }

}
